<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    document.addEventListener('visibilitychange', this.onVisibilitychange);
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.onVisibilitychange)
  },
  methods: {
    onVisibilitychange(){
      if (!document.hidden) {
        this.$store.dispatch('StopFlash')
      }
    }
  }
};
</script>

<style>
body{
  margin: 0;
}
*{
  margin: 0;
}
a:focus,
a:active {
  outline: none;
}

a,
a:focus,
a:hover {
  cursor: pointer;
  color: inherit;
  text-decoration: none;
}
#app {
  width: 100%;
  height: 100vh;
  font-size: 14px;
  color: #2A2A2A;
}
</style>
